import { render, staticRenderFns } from "./SubscriptionDiscountDeleteModal.vue?vue&type=template&id=4b9133a5"
import script from "./SubscriptionDiscountDeleteModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionDiscountDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports